export default function refreshCaptcha(btnClass, captchaImgClass) {
    const captchaRefreshBtn = document.querySelector(btnClass);
    captchaRefreshBtn?.addEventListener('click', (e)=> {
        e.preventDefault();
        const captchaImg = document.querySelector(captchaImgClass);
        let imgSrc = captchaImg.getAttribute('src');
        imgSrc = imgSrc.split('?')[0] + '?' + new Date().getTime();
        captchaImg.setAttribute('src', imgSrc);
        document.querySelector('#pp-captcha-token').value = '';
    });

    const captchaInput = document.querySelectorAll('.captcha-input input, #pp-captcha-token');
    captchaInput.forEach(input => {
        input.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                document.querySelector('form.container-form')?.submit();
            }
        });
    });
}